import React, { useState } from 'react';
import {
    TextField,
    InputAdornment,
    IconButton,
    TextFieldProps,
} from '@mui/material';
import { Visibility, VisibilityOff } from '@mui/icons-material';

type PasswordFieldProps = {
    label?: string;
    value: string;
    onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
    error?: boolean;
    helperText?: string;
    showToggle?: boolean;
} & Omit<
    TextFieldProps,
    'type' | 'value' | 'onChange' | 'error' | 'helperText'
>;

const PasswordField: React.FC<PasswordFieldProps> = ({
    label = 'Password',
    value,
    onChange,
    error,
    helperText,
    showToggle = true,
    ...rest
}) => {
    const [showPassword, setShowPassword] = useState(false);

    return (
        <TextField
            type={showPassword ? 'text' : 'password'}
            label={label}
            value={value}
            onChange={onChange}
            error={error}
            helperText={helperText}
            fullWidth
            required
            margin="normal"
            InputProps={{
                endAdornment: showToggle ? (
                    <InputAdornment
                        position="end"
                        sx={{ alignItems: 'center' }}
                    >
                        <IconButton
                            onClick={() => setShowPassword((prev) => !prev)}
                            edge="end"
                            size="small"
                            sx={{ p: 1 }}
                        >
                            {showPassword ? <VisibilityOff /> : <Visibility />}
                        </IconButton>
                    </InputAdornment>
                ) : undefined,
            }}
            {...rest}
        />
    );
};

export default PasswordField;
